import {
  StyledDivider,
  StyledDividerLine,
  StyledDividerText,
} from './styledComponents';

const AuthDivider = () => (
  <StyledDivider>
    <StyledDividerLine />
    <StyledDividerText>or</StyledDividerText>
    <StyledDividerLine />
  </StyledDivider>
);

export default AuthDivider;
